<template>
  <PageLayout
    title="Publikum"
    :prev="prevRoute"
    :show-save-draft="false"
    :next="true"
    @next="onNext"
    ref="audienceType"
  >
    <ui-section
      title="Koho chcete oslovit?"
      subtitle="Zobrazujte své reklamy lidem podle toho, jak s vámi v minulosti interagovali"
    >
      <div class="d-flex py-0 mb-6">
        <ui-card-btn
          v-for="type in audiencesTypes"
          class="mr-4"
          small
          :disabled="!canEdit"
          :key="'card-' + type.key"
          :active="type.key === audienceType"
          :icon="type.ico"
          :tooltip="type.tooltip"
          @click.prevent="onAudienceTypeChange(type.key)"
        >
          {{ type.name }}
        </ui-card-btn>
      </div>
      <v-alert>
        Cílením se zaměřujete pouze na nastavení demografických údajů a okruhů
        zájmů. Návštěvníci, sledující, klienti pracují s vlastními okruhy
        uživatelů a podobnými okruhy uživatelů. A také s demografickými údaji a
        okruhy zájmů.
      </v-alert>
      <v-alert
        v-if="audienceType"
        class="mb-8"
        outlined
        type="info"
        icon="mdi-information-outline"
      >
        <strong class="info--text">{{
          findAudienceType(audienceType).name
        }}</strong>
        {{ findAudienceType(audienceType).description }}
      </v-alert>
    </ui-section>

    <ui-section
      v-if="audienceType"
      :title="audienceTypeTexts.title"
      :subtitle="audienceTypeTexts.subtitle"
    >
      <div class="d-flex py-0 mb-6">
        <ui-card-btn
          v-for="subType in findAudienceSubTypes(audienceType)"
          class="mr-4"
          small
          :key="`card-${audienceType}-${subType.key}`"
          :active="subType.key === audienceSubType"
          :disabled="!canEdit"
          :icon="subType.ico"
          @click.prevent="audienceSubType = subType.key"
          >{{ subType.name }}</ui-card-btn
        >
      </div>
      <v-alert v-if="audienceType === 'audience'">
        Jako nové publikum si můžete zvolit existující vlastní okruh uživatelů,
        kteří interagovali s nějakou částí vašeho byznysu. Nové publikum ze
        šablony vám umožní využít šablonu pro zadání URL adresy a tím vytvořit
        interakční bod na jehož základě se nové publikum vytvoří. Podobné
        publikum vychází z nějakého existujícího publika na základě jeho
        vlastností a tím zahrne podobné lidi.
      </v-alert>

      <set-of-audiences
        v-if="audienceSubType === 'setOf'"
        :store-namespace="storeNamespace"
      />

      <lookalike-audience
        v-if="audienceSubType === 'lookalike'"
        :store-namespace="storeNamespace"
      />

      <template-audience
        v-if="audienceSubType === 'template'"
        :store-namespace="storeNamespace"
      />

      <saved-audiences
        v-if="audienceSubType === 'saved'"
        :store-namespace="storeNamespace"
        :audience-type="audienceType"
      />
    </ui-section>
  </PageLayout>
</template>

<script>
import { get, sync } from "vuex-pathify"

import PageLayout from "@/components/page/ads/edit/PageLayout.vue"
import LookalikeAudience from "@/components/ui/audiences/LookalikeAudience.vue"
import SetOfAudiences from "@/components/ui/audiences/SetOfAudiences.vue"
import SavedAudiences from "@/components/ui/audiences/SavedAudiences.vue"
import TemplateAudience from "@/components/ui/audiences/TemplateAudience.vue"
import validation from "@/mixins/validation"

export default {
  name: "AudienceType",
  components: {
    PageLayout,
    LookalikeAudience,
    SetOfAudiences,
    SavedAudiences,
    TemplateAudience,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    nextRoute: {
      type: String,
      default: null,
    },
    prevRoute: {
      type: String,
      default: null,
    },
    storeNamespace: {
      type: String,
      required: true,
    },
  },
  mixins: [validation],
  computed: {
    ...get("enumerations", [
      "audiencesTypes",
      "findAudienceType",
      "findAudienceSubTypes",
    ]),
    ...sync("app", ["videoTutorial"]),

    audienceTypeTexts() {
      let result = {
        title: null,
        subtitle: null,
      }

      switch (this.audienceType) {
        case "targeting":
          result = {
            title:
              "Zvolte, zda chcete vytvořit nové cílení, nebo pracovat s již vytvořeným",
            subtitle:
              "Správné zacílení je jedna z nejdůležitějších částí publikace reklamy.",
          }
          break
        case "custom":
          result = {
            title: "Zvolte jednu z možností",
            subtitle:
              "Správné zacílení je jedna z nejdůležitějších částí publikace reklamy.",
          }
          break
      }

      return result
    },

    canEdit() {
      return !(this.adId || this.audienceId)
    },
  },
  methods: {
    onAudienceTypeChange(val) {
      this.audienceType = val
      this.audienceSubType = null
    },
    onNext() {
      if (this.validatePage()) {
        this.$router.push(this.nextRoute)
      }
    },
    validatePage() {
      if (this.audienceType === null || this.audienceSubType === null) {
        return false
      }
      if (!this.isValidAll()) {
        return false
      }

      return true
    },
  },
  beforeCreate() {
    const storeNamespace = this.$options.propsData.storeNamespace

    if (!this.$options.computed) {
      this.$options.computed = {}
    }

    Object.assign(this.$options.computed, {
      ...get(`${storeNamespace}/model@`, ["adId"]),
      ...sync(`${storeNamespace}/model@audience`, [
        "audienceId",
        "audienceType",
        "audienceSubType",
      ]),
    })
  },
  mounted() {
    this.videoTutorial = "https://player.vimeo.com/video/693565680?h=a1614ca36e"
  },
}
</script>
